// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage'; // Import the getStorage function
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration object
const firebaseConfig = {
  apiKey: "AIzaSyBfp8T1oujEM65TuJIDhjgcyS-dhCLDW5Q",
  authDomain: "almostinvisible-pro.firebaseapp.com",
  databaseURL: "https://almostinvisible-pro-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "almostinvisible-pro",
  storageBucket: "almostinvisible-pro.appspot.com",
  messagingSenderId: "915469742910",
  appId: "1:915469742910:web:d42e67fcee6a5f6d90b26f",
  measurementId: "G-LC2ECY2BCB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // Initialize Firebase Storage

export { auth, db, storage, app };


